// Tap-to-explain bottom sheet for stats (Streak, Coins, Fit score, …).
// Mobile-first: slides up from the bottom; tap backdrop or "Got it" to close.
import React from "react";
import { X } from "lucide-react";

export const STAT_INFO = {
    streak: {
        title: "Streak",
        body: "Days in a row you've hit your daily goal — earn 10 coins in at least one workout (one set, about 90 seconds). Longer streaks unlock coin multipliers, and you can protect a streak with a Shield from your profile.",
    },
    coins: {
        title: "Coins",
        body: "You earn coins for every rep. Daily streaks boost how many you earn per rep. Spend them on streak protection (Shield, Revive) or stake them to enter challenges.",
    },
    fit: {
        title: "Fit score",
        body: "Your overall fitness level in the app. It grows with every completed rep — harder exercises grow it faster.",
    },
    workouts: {
        title: "Workouts this week",
        body: "Sessions you've completed in the last 7 days. Each one earns coins and counts toward your daily streak goal.",
    },
};

export default function StatInfoSheet({ info, onClose }) {
    if (!info) return null;
    return (
        <div className="sheet-back" onClick={onClose} data-testid="stat-info-sheet">
            <div className="sheet" onClick={(e) => e.stopPropagation()}>
                <button className="sheet-x" onClick={onClose} aria-label="Close" data-testid="stat-info-close">
                    <X size={18} />
                </button>
                <h3 className="sheet-h">{info.title}</h3>
                <p className="sheet-p">{info.body}</p>
                <button className="btn-block mt-5" onClick={onClose} data-testid="stat-info-got-it">
                    Got it
                </button>
            </div>
        </div>
    );
}
